var map = {
	"./LogOut.svg": 45650,
	"./add.svg": 14780,
	"./addUser.svg": 86555,
	"./admin.svg": 23759,
	"./alt_route.svg": 26911,
	"./arrow-up-ios.svg": 94258,
	"./arrowDown.svg": 93647,
	"./arrowDownWhite.svg": 37978,
	"./arrowUp.svg": 82238,
	"./arrows.svg": 59177,
	"./badge-orange.svg": 1019,
	"./badge.svg": 67036,
	"./better_wallet.svg": 31254,
	"./better_wallet_green.svg": 80486,
	"./better_wallet_red.svg": 12836,
	"./bitcoin-yupa-orange.svg": 62006,
	"./bitcoin.svg": 62501,
	"./bitcoin_orange.svg": 34069,
	"./bollt.svg": 76099,
	"./bolt.svg": 48628,
	"./bolt_filled.svg": 16075,
	"./bolt_filled_gold.svg": 16,
	"./bolt_gold.svg": 86492,
	"./bolt_white.svg": 82102,
	"./calendar.svg": 90874,
	"./camera.svg": 16508,
	"./cash.svg": 94468,
	"./check-ios.svg": 42867,
	"./closedEye.svg": 63307,
	"./copy-green.svg": 88887,
	"./copy.svg": 47918,
	"./danger-thic-red.svg": 10405,
	"./danger-thic.svg": 81922,
	"./dashboard.svg": 77553,
	"./dollar.svg": 46025,
	"./done-circle.svg": 54439,
	"./done-green.svg": 35430,
	"./done.svg": 63223,
	"./edit.svg": 98377,
	"./edit_pen.svg": 43081,
	"./exclamation-red.svg": 31249,
	"./exclamation.svg": 15978,
	"./eye.svg": 45564,
	"./hash.svg": 47341,
	"./history.svg": 94163,
	"./home.svg": 32520,
	"./id.svg": 19341,
	"./inbox.svg": 43421,
	"./inbox_gold.svg": 40926,
	"./info.svg": 67292,
	"./invoice.svg": 870,
	"./key.svg": 34938,
	"./menu.svg": 85674,
	"./money.svg": 54613,
	"./notifications.svg": 76513,
	"./openNewTab.svg": 76466,
	"./outbox.svg": 14479,
	"./outbox_gold.svg": 6630,
	"./outgoing-mail-orange.svg": 49554,
	"./outgoing-mail.svg": 57693,
	"./paid-green.svg": 89185,
	"./paid-red.svg": 84845,
	"./paid.svg": 89274,
	"./pos.svg": 22504,
	"./receive-white.svg": 12443,
	"./receive.svg": 43878,
	"./search.svg": 79262,
	"./send-white.svg": 11658,
	"./send.svg": 89459,
	"./settings-orange.svg": 6040,
	"./settings.svg": 20677,
	"./shield.svg": 33558,
	"./square-ios.svg": 53700,
	"./square-plus-ios.svg": 90832,
	"./tag.svg": 95084,
	"./wallet.svg": 3740,
	"./walletWhite.svg": 38004,
	"./x.svg": 74118,
	"./xBlack.svg": 84473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;